"use client";

import { DEMO_CALENDAR_LINK } from "@/lib/constants/booking";
import { UnifiedModal, useModalManager } from "@/app/(public)/shared/components/UnifiedModal";
import { Button } from "@/app/(public)/shared/ui/Button";
import { motion } from "framer-motion";

export default function Support() {
  const { openModal, closeModal, isModalOpen } = useModalManager();

  const contactMethods = [
    {
      title: "Talk to Sales",
      description: "Schedule a 30-minute consultation to discuss your event needs and see how Nowadays can help.",
      action: "Schedule a call",
      onClick: () => openModal("demo"),
    },
    {
      title: "Customer Support",
      description: "Get help with your existing events, technical questions, or general inquiries.",
      action: "Email us",
      link: "mailto:events@nowadays.ai",
    },
    {
      title: "General Inquiries",
      description: "Have a question about our services, pricing, or want to learn more about Nowadays?",
      action: "Get in touch",
      link: "mailto:hello@nowadays.ai",
    },
  ];

  return (
    <div className="min-h-screen overflow-x-hidden container-page">
      {/* Contact Methods Section */}
      <section className="container-top">
        <div className="">
          <div className="text-center flex flex-col gap-6 mb-16">
            <h2 className="text-h2 text-landing-primary-sand">How can we help?</h2>
            <p className="text-body-lg text-landing-secondary-sand max-w-[530px] mx-auto">
              Whether you're ready to get started or just have questions, we're here to help you plan amazing events.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {contactMethods.map((method, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100"
              >
                <h3 className="text-h3 text-landing-primary-sand mb-4">{method.title}</h3>
                <p className="text-body-lg text-landing-secondary-sand mb-6">{method.description}</p>
                <Button
                  variant="primary"
                  color="primary"
                  size="md"
                  onClick={() => (method.onClick ? method.onClick() : window.open(method.link, "_blank"))}
                  className="w-full"
                >
                  {method.action}
                </Button>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Preview Section */}
      <section className="py-24">
        <div className="text-center">
          <h2 className="text-h2 text-landing-primary mb-6">Have a quick question?</h2>
          <p className="text-body-lg text-landing-secondary mb-8 max-w-[530px] mx-auto">
            Check out our frequently asked questions for quick answers to common inquiries.
          </p>
          <Button variant="primary" color="primary" size="md" onClick={() => (window.location.href = "/faq")}>
            View FAQs
          </Button>
        </div>
      </section>

      {/* Demo Modal */}
      <UnifiedModal
        type="cal"
        isOpen={isModalOpen("demo")}
        onClose={() => closeModal("demo")}
        title="Schedule a Call"
        subtitle="Talk to our sales team about your event needs"
        size="lg"
        calLink={DEMO_CALENDAR_LINK}
        fallbackText="Book your call with our team"
      />
    </div>
  );
}
